import Vue              from 'vue'
import VueRouter        from 'vue-router'

import Home from '../views/Home.vue'
import Contracts from '../views/admin/Contracts';
import Printers from '../views/admin/Printers';
import Printer from '../views/admin/Printer';
import Bigfox from '../views/admin/Bigfox';
import Profiles from '../views/config/Profiles';
import CreateProfile from '../views/config/CreateProfile';
import CreateContract from '../views/admin/CreateContract';
import ViewBigfox from '../views/admin/ViewBigfox';
import Overview from '../views/report/Overview';
import ViewContract from '../views/admin/ViewContract';
import CGroups from '@/views/config/CGroups';
import CreateInvoice from '@/views/admin/CreateInvoice';
import Models from '@/views/config/Models';
import Tasks from '@/views/overview/Tasks';
import TlIntegration from '@/components/TlIntegration';
import Integrations from '@/views/config/Integrations';
import Invoices from '@/views/admin/Invoices';
import Login from '@/views/Login';
import Main from '@/views/Main';
import PriceIndexation from '@/views/admin/PriceIndexation';
import Help from '@/views/Help';

Vue.use(VueRouter);

const routes = [
    { path: '/', component: Home, meta: { requiresAuth: true } },
    { path: '/login', component: Login, meta: { requiresAuth: false } },
    {
        path: '/main',
        component: Main,
        meta: { requiresAuth: true },
        children:
        [
            { path: 'admin/contracts/createInvoice/:id', component: CreateInvoice, props: true },
            { path: 'admin/contracts', component: Contracts, meta: { title: 'Contracten'} },
            { path: 'admin/contracts/create', component: CreateContract },
            { path: 'admin/contracts/view/:id', component: ViewContract, props: true, meta: { title: 'Contract' } },
            { path: 'admin/contracts/edit/:id', component: CreateContract, props: true },
            { path: 'admin/printers', component: Printers },
            { path: 'admin/printers/view/:id', component: Printer, props: true, meta: { title: 'Printer' } },
            { path: 'admin/bigfox', component: Bigfox, meta: { title: 'Bigfox '} },
            { path: 'admin/bigfox/view/:id', component: ViewBigfox, props: true},
            { path: 'admin/invoices', component: Invoices },
            {
                path: 'admin/priceIndexation',
                component: PriceIndexation,
                props: route => ({ contractIds: route.query.contractIds.map(t => parseInt(t)) })
            },
            { path: 'help', component: Help },
            { path: 'config/models', component: Models, props: true },
            { path: 'config/cgroups', component: CGroups, props: true, meta: { title: 'Tellergroepen' } },
            { path: 'config/profiles', component: Profiles },
            { path: 'config/profiles/create', component: CreateProfile },
            { path: 'config/profiles/create/from/:from', component: CreateProfile, props: true },
            { path: 'config/profiles/edit/:id', component: CreateProfile, props: true },
            { path: 'overview/tasks', component: Tasks, meta: { title: 'Takenlijst' } },
            { path: 'report/overview', component: Overview },
            { path: 'integration/teamleader', component: TlIntegration, props: true },
            { path: 'config/integrations', component: Integrations }
        ]
    }
];

const defScroll = {x: 0, y: 0};

const router = new VueRouter(
    {
        mode: 'history',
        base: process.env.BASE_URL,
        routes,
        scrollBehavior(to, from, saved) { return saved ? saved : defScroll }
    }
);

export default router
